import React, { Dispatch, useState } from 'react';
import { Col, Row, Form, DatePicker, Collapse } from 'antd';
import { Action } from 'typesafe-actions';
import { useDispatch, useSelector } from 'react-redux';
import { CALENDAR_LOCALE } from '../../../../utils/calendar-locale';
import FilterContainer from '../../../../components/FilterContainer';
import { ApplicationState } from '../../../../store';
import {
  cleanStateMoviEntrada,
  filterMovimentacoes,
  loadRequest,
} from '../../../../store/ducks/movimentacoes/actions';
import CollapseTitle from '../../../../components/TitleCollapseFilter';
import FilterBtn from '../../../../components/FilterBtn';
import ClearFilterBtn from '../../../../components/ClearFilterBtn';
import CollapseFilter from '../../../../components/CollapseFilter';
import SelectProduto from '../../../../components/SelectProduto';
import SelectPagadorArmazenagem from '../../../../components/SelectPagadorArmazenagem';
import SelectEmitente from '../../../../components/SelectEmitente';
import {SelectParceiroDepositante} from '../../../../components/SelectParceiroDepositante';
import SelectNumUnico from '../../../../components/SelectNumUnico';
import SelectNumNota from '../../../../components/SelectNumNota';
import SelectStatus from '../../../../components/SelectStatus';
import moment from 'moment';
import TitleFilter from '../../../../components/TextFilter';
import { SelectDepositante } from '../../../../components/SelectDepositante';
import { ROLE } from 'utils/roles';

const Filter: React.FC = () => {
  const { RangePicker } = DatePicker;
  const { Panel } = Collapse;
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil)
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const pagCurrent = useSelector(
    (state: ApplicationState) => state.Movimentacoes.pagination.current
  );
  const sorter = useSelector((state: ApplicationState) => state.Movimentacoes.sorter);

  const [filter, setFilter] = useState<object | undefined | any>();
  // eslint-disable-next-line
  const [nuNota, setNuNota] = useState<number>();
  // eslint-disable-next-line
  const [numNota, setNumNota] = useState<number>();
  // eslint-disable-next-line
  const [prod, setProd] = useState<any>();
  // eslint-disable-next-line
  const [emissorNota, setEmissorNota] = useState<any>();
  // eslint-disable-next-line
  const [pagadorArmazenagem, setPagadorArmazenagem] = useState<any>();
  const dispatch = useDispatch<Dispatch<Action>>();

  const clearFilter = () => {
    dispatch(cleanStateMoviEntrada());
    localStorage.removeItem(`pagadorArmazenagem${window.location.pathname}`);
    localStorage.removeItem(`produto${window.location.pathname}`);
    localStorage.removeItem(`emissorNota${window.location.pathname}`);
    localStorage.removeItem(`depositante${window.location.pathname}`);
    localStorage.removeItem(`codDepositante${window.location.pathname}`);
    localStorage.removeItem(`nuNota${window.location.pathname}`);
    localStorage.removeItem(`numNota${window.location.pathname}`);
    localStorage.removeItem(`status${window.location.pathname}`);
    localStorage.removeItem(window.location.pathname + `valuesFilter`);
    dispatch(loadRequest({}, inscricaoAtiva, cddAtivo?.codCdd, sorter));
  };

  const onFilter = (values: any) => {
    const { dtLancamento, dtEmissao, ...rest } = values;
    let periodoLancamentoInicio, periodoLancamentoFim, periodoEmissaoInicio, periodoEmissaoFim;

    if (dtLancamento) [periodoLancamentoInicio, periodoLancamentoFim] = dtLancamento;

    if (dtEmissao) [periodoEmissaoInicio, periodoEmissaoFim] = dtEmissao;

    localStorage.setItem(
      window.location.pathname + 'valuesFilter',
      JSON.stringify({
        periodoLancamentoInicio: localStorageItensPersist.periodoLancamentoInicio
          ? localStorageItensPersist.periodoLancamentoInicio
          : periodoLancamentoInicio === undefined
            ? undefined
            : moment(periodoLancamentoInicio).format(),
        periodoLancamentoFim: localStorageItensPersist.periodoLancamentoFim
          ? localStorageItensPersist.periodoLancamentoFim
          : periodoEmissaoFim === undefined
            ? undefined
            : moment(periodoLancamentoFim).format(),
        periodoEmissaoInicio: localStorageItensPersist.periodoEmissaoInicio
          ? localStorageItensPersist.periodoEmissaoInicio
          : periodoEmissaoInicio === undefined
            ? undefined
            : moment(periodoEmissaoInicio).format(),
        periodoEmissaoFim: localStorageItensPersist.periodoEmissaoFim
          ? localStorageItensPersist.periodoEmissaoFim
          : periodoEmissaoFim === undefined
            ? undefined
            : moment(periodoEmissaoFim).format(),
        ...rest,
      })
    );

    setFilter({
      periodoLancamentoInicio: periodoLancamentoInicio
        ? moment(periodoLancamentoInicio).format()
        : localStorageItensPersist.periodoLancamentoInicio,
      periodoLancamentoFim: periodoLancamentoFim
        ? moment(periodoLancamentoFim).format()
        : localStorageItensPersist.periodoLancamentoFim,
      periodoEmissaoInicio: periodoEmissaoInicio
        ? moment(periodoEmissaoInicio).format()
        : localStorageItensPersist.periodoEmissaoInicio,
      periodoEmissaoFim: periodoEmissaoFim
        ? moment(periodoEmissaoFim).format()
        : localStorageItensPersist.periodoEmissaoFim,
      codProduto: prod && Number(prod),
      ...rest,
    });
  };


  const localStorageItensPersist: any = JSON.parse(
    localStorage.getItem(window.location.pathname + `valuesFilter`) || '{}'
  );

  const {
    periodoLancamentoInicio,
    periodoLancamentoFim,
    periodoEmissaoInicio,
    periodoEmissaoFim,
  } = localStorageItensPersist;

  return (
    <CollapseFilter
      filter={filter}
      pagination={pagCurrent}
      sorter={sorter}
      loadRequest={loadRequest}
      saveFilter={filterMovimentacoes}
      saveLocalStorage={'persist:Movimentacoes'}
    >
      <Panel header={<CollapseTitle>Filtro</CollapseTitle>} key="1">
        <FilterContainer
          onFilter={onFilter}
          initialValues={{
            ...localStorageItensPersist,
            periodoLancamentoInicio: periodoLancamentoInicio
              ? moment(periodoLancamentoInicio, 'DD/MM/YYYY')
              : undefined,
            periodoLancamentoFim: periodoLancamentoFim
              ? moment(periodoLancamentoFim, 'DD/MM/YYYY')
              : undefined,
            periodoEmissaoInicio: periodoEmissaoInicio
              ? moment(periodoEmissaoInicio, 'DD/MM/YYYY')
              : undefined,
            periodoEmissaoFim: periodoEmissaoFim
              ? moment(periodoEmissaoFim, 'DD/MM/YYYY')
              : undefined,
          }}
        >
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectProduto setProduto={setProd} />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectNumUnico setNuNota={setNuNota} />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectNumNota setNumNotas={setNumNota} />
            </Col>

            <Col md={6} sm={24} xs={24}>
              <SelectStatus />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col md={6} sm={24} xs={24}>
              <SelectPagadorArmazenagem
                setFiltro={filter}
                setPagArmazenagem={setPagadorArmazenagem}
              />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <SelectEmitente setEmitent={setEmissorNota} />
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item
                label={<TitleFilter>Período emissão da nota</TitleFilter>}
                name="dtEmissao"
              >
                {periodoEmissaoInicio === undefined ? (
                  <RangePicker data-cy="dtEmissao"
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                  />
                ) : (
                  <RangePicker data-cy="dtEmissao"
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                    defaultValue={[
                      moment(periodoEmissaoInicio, 'DD/MM/YYYY'),
                      moment(periodoEmissaoFim, 'DD/MM/YYYY'),
                    ]}
                  />
                )}
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <Form.Item label={<TitleFilter>Período lançamento</TitleFilter>} name="dtLancamento">
                {periodoLancamentoInicio === undefined ? (
                  <RangePicker data-cy="dtLancamento"
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                  />
                ) : (
                  <RangePicker
                    style={{ width: '100%' }}
                    locale={CALENDAR_LOCALE}
                    format="DD/MM/YYYY"
                    defaultValue={[
                      moment(periodoLancamentoInicio, 'DD/MM/YYYY'),
                      moment(periodoLancamentoFim, 'DD/MM/YYYY'),
                    ]}
                  />
                )}
              </Form.Item>
            </Col>
            <Col md={6} sm={24} xs={24}>
              {perfil === ROLE.DEPOSITANTE
                ? <SelectParceiroDepositante />
                : <SelectDepositante />
              }
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col md={6} sm={24} xs={24}>
              <ClearFilterBtn onClick={clearFilter}>Limpar filtros</ClearFilterBtn>
            </Col>
            <Col md={6} sm={24} xs={24}>
              <FilterBtn>Filtrar</FilterBtn>
            </Col>
          </Row>
        </FilterContainer>
      </Panel>
    </CollapseFilter>
  );
};

export default Filter;
